import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  },
  remoteRequests: [],
  remoteRequestsExport: [],
  remoteRequest: {},
  totalRemoteRequests: []
};

// getters
export const getters = {
  remoteRequests: state => state.remoteRequests,
  totalRemoteRequests: state => state.totalRemoteRequests,
  remoteRequestsExport: state => state.remoteRequestsExport,
  remoteRequest: state => state.remoteRequest,
  pagination: state => state.pagination
};

// mutations
export const mutations = {
  [types.REMOTE_REQUEST.FETCH_REMOTE_REQUEST](state, remoteRequests) {
    state.remoteRequests = remoteRequests;
    state.pagination.from = remoteRequests.from;
    state.pagination.to = remoteRequests.to;
    state.pagination.totalPage = remoteRequests.last_page;
    state.pagination.path = remoteRequests.path;
    state.pagination.currentPage = remoteRequests.current_page;
    state.pagination.totalRecord = remoteRequests.total;
    state.pagination.perPage = remoteRequests.per_page;
  },
  [types.REMOTE_REQUEST.FETCH_TOTAL_REMOTE_REQUEST](state, totalRemoteRequests) {
    state.totalRemoteRequests = totalRemoteRequests;
  },
  [types.REMOTE_REQUEST.FETCH_REMOTE_REQUEST_EXPORT](
    state,
    remoteRequests
  ) {
    state.remoteRequestsExport = remoteRequests;
  },
  [types.REMOTE_REQUEST.SHOW_REMOTE_REQUEST](state, remoteRequest) {
    state.remoteRequest = remoteRequest;
  }
};

// actions
export const actions = {
  async listRemoteRequest({ commit }, payload) {
    const response = await axios.get(api.LIST_REMOTE_REQUEST, {
      params: {
        per_page: payload.optionPage,
        page: payload.currentPage,
        employee_info: payload.employeeInfo,
        position_id: payload.positionId,
        division_code: payload.divisionCode,
        start_date: payload.start_date,
        end_date: payload.end_date,
        approve_person: payload.approvePerson,
        status: payload.status
      }
    });
    commit(
      types.REMOTE_REQUEST.FETCH_REMOTE_REQUEST,
      response.data.remoteRequests
    );
    commit(
      types.REMOTE_REQUEST.FETCH_TOTAL_REMOTE_REQUEST,
      response.data.totalRemoteRequests
    );
  },

  async listRemoteRequestExport({ commit }, payload) {
    const response = await axios.get(api.LIST_REMOTE_REQUEST, {
      params: {
        employee_info: payload.employeeInfo,
        position_id: payload.positionId,
        division_code: payload.divisionCode,
        start_date: payload.start_date,
        end_date: payload.end_date,
        approve_person: payload.approvePerson,
        status: payload.status,
        export: payload.export
      }
    });
    commit(
      types.REMOTE_REQUEST.FETCH_REMOTE_REQUEST_EXPORT,
      response.data.remoteRequests
    );
  },

  async detailRemoteRequest({ commit }, remoteRequestId) {
    const response = await axios.get(
      api.SHOW_REMOTE_REQUEST + "/" + remoteRequestId
    );
    commit(types.REMOTE_REQUEST.SHOW_REMOTE_REQUEST, response.data);
  }
};
